import http from '../_http'

const agent = {
  //default
  summaryAgent: (m) => { return http.get(`manager/wsfinder/agent`, m); },
  listAgent: (m) => { return http.post(`manager/wsfinder/agent/list`, m); },
  detailAgent: (m) => { return http.get(`manager/wsfinder/agent/${m.id}`); },

  //crud
  insertAgent: (m) => { return http.post(`manager/wsfinder/agent`, m); },
  updateAgent: (m) => { return http.put(`manager/wsfinder/agent`, m); },
  deleteAgent: (m) => { return http.delete(`manager/wsfinder/agent/${m.id}`); },

  //version
  versionAgent: (m) => { return http.get(`manager/wsfinder/agent/version`, m); },
}

export default agent

export { agent }